import BaseApi from "../../BaseApi";

export class API extends BaseApi {
  constructor() {
    super();
    this.site = scriptsData.siteUrl;
  }
  
  async loadContent(args) {
    
    const query = { ...args, 
      order: 'ASC',
      orderby: 'title'
    };

    let queryString = new URLSearchParams(query).toString();
    queryString = queryString.length ? `?${queryString}` : '';
    const apiUrl = `${this.site}wp-json/wp/v2/get-comercios${queryString}`;
    const { data, totalPages } = await this.get(apiUrl);
    
    return { data, totalPages }

  }

}
